import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "./config";
import '../css/Profile.css';

const safeJson = async res => {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (error) {
    console.error('Response is not JSON:', text);
    return null;
  }
};

function Profile() {
  const navigate = useNavigate();
  const user = useMemo(
    () => JSON.parse(localStorage.getItem('user')),
    []
  );

  const [stats, setStats] = useState(null);
  const [rankHistory, setRankHistory] = useState([]);
  const [checkinStatus, setCheckinStatus] = useState(null);
  const [latestGroup, setLatestGroup] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!user) navigate('/');
  }, [user, navigate]);

  const fetchData = useCallback(async () => {
    if (!user) return;

    try {
      const [statsRes, rankRes, checkinRes, groupRes] = await Promise.all([
        fetch(`${API_BASE}/api/checkin/player-stats/all/${user.user_id}`),
        fetch(`${API_BASE}/api/checkin/rank-history/${user.user_id}`),
        fetch(`${API_BASE}/api/checkin/status/${user.user_id}`),
        fetch(`${API_BASE}/api/groups/open/latest`)
      ]);

      setStats(await safeJson(statsRes));
      setRankHistory(await safeJson(rankRes) || []);
      setCheckinStatus(await safeJson(checkinRes));
      setLatestGroup(await safeJson(groupRes));
    } catch (error) {
      console.error('FETCH ERROR:', error);
    }
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleQuickCheckin = async () => {
    if (!latestGroup) {
      setMessage('NO ACTIVE GROUP');
      return;
    }

    await fetch(`${API_BASE}/api/checkin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: user.user_id,
        Group_Name: latestGroup.Group_Name
      })
    });

    setMessage('CHECK-IN SUCCESS');
    fetchData();
  };

  const handleCheckout = async () => {
    await fetch(`${API_BASE}/api/checkin/${user.user_id}`, {
      method: 'DELETE'
    });

    setMessage('CHECK-OUT SUCCESS');
    fetchData();
  };

  if (!user) return null;

  return (
    <div className="sport-container">

      <div className="glass-card header-card">
        <div className="avatar">🏸</div>
        <h2>{user.name}</h2>
        <div className="rank-pill">{user.level_rank}</div>
        <div className="point-pill">⭐ {user.point} pts</div>
      </div>

      <div className="glass-row">
        <div className="glass-card stat-card win-card">
          <p>WIN</p>
          <h3>{stats?.win || 0}</h3>
        </div>

        <div className="glass-card stat-card draw-card">
          <p>DRAW</p>
          <h3>{stats?.draw || 0}</h3>
        </div>

        <div className="glass-card stat-card lose-card">
          <p>LOSE</p>
          <h3>{stats?.lose || 0}</h3>
        </div>
      </div>

      <div className="glass-card history-card">
        <h3>🏆 Rank History</h3>
        {rankHistory.map((item, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-dot"></div>
            <div>
              <b>{new Date(item.created_at).toLocaleDateString()}</b>
              <p>{item.old_rank} ➜ {item.new_rank} (+{item.point})</p>
            </div>
          </div>
        ))}
      </div>

      <div className="action-zone">
        {!checkinStatus?.checkedIn ? (
          <button className="main-btn" onClick={handleQuickCheckin}>
            QUICK CHECK-IN
          </button>
        ) : (
          <div className="glass-card checked-box">
            <p>ACTIVE GROUP</p>
            <h4>{checkinStatus.Group_Name}</h4>
            <button className="checkout-btn" onClick={handleCheckout}>
              CHECK-OUT
            </button>
          </div>
        )}
      </div>

      {message && <div className="toast">{message}</div>}

      <div className="bottom-nav">
        <div onClick={() => navigate('/home')}>🏠</div>
        <div onClick={() => navigate('/stats')}>📊</div>
        <div onClick={() => navigate('/checkin')}>📍</div>
        <div className="active">👤</div>
      </div>

    </div>
  );
}

export default Profile;
